import React, { useState, useEffect } from "react";
import { useParams, NavLink } from "react-router-dom";
import { Spinner } from "reactstrap";
import Header from "../../Components/Layout/Header/Header";
import Footer from "../../Components/Layout/Footer/Footer";
import combinedServices from "../../shared/services/user-service";
import { findMinFastTime } from "../../utils/MinimumFastTime";
import Button from "@mui/material/Button";
import "./Club_result.scss";

const EventPodiumPage = () => {
  const { id } = useParams();
  const [title, setTitle] = useState("");
  const [podiumList, setPodiumList] = useState([]);
  const [scoreRacer, setScoreRacer] = useState([]);
  const [totalRounds, setTotalRounds] = useState(3);
  const [viewMode, setViewMode] = useState("podium");
  const [podiumViewMode, setPodiumViewMode] = useState("full");
  const [isLoading, setIsLoading] = useState(true);
  const [shootoutWinners, setShootoutWinners] = useState({});
  const scorenImg =
    "https://nambaweb.s3.ap-south-1.amazonaws.com/frontend-static-image/scorenotfound.png";

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const [eventRes, podiumRes, scoreRes] = await Promise.all([
          combinedServices.getClassByEventId(id),
          combinedServices.listPodiumClasses(id),
          combinedServices.getScore(id),
        ]);

        if (eventRes?.data) {
          setTitle(eventRes.data.full_title || "");
          setTotalRounds(eventRes.data.rounds_per_class || 3);
        }

        if (podiumRes?.data) setPodiumList(podiumRes.data);

        if (scoreRes) {
          const sorted = [...scoreRes].sort((a, b) => {
            if (a.class_Name === b.class_Name) return b.total - a.total;
            return a.class_Name.localeCompare(b.class_Name);
          });
          for (let item of sorted) {
            if (item.score_with_reason != null) {
              for (let key in item) {
                if (key.startsWith("round") && item[key] == 0) {
                  for (let r of item.score_with_reason) {
                    if (r.round == key && r.reason.toLowerCase() !== "normal") {
                      item[key] = r.reason;
                    }
                  }
                }
              }
            }
          }
          setScoreRacer(sorted);

          const winners = {};
          try {
            const res = await combinedServices.getShootoutResultsByEvent(id);
            if (res.status === 200 && Array.isArray(res.data)) {
              res.data.forEach((row) => {
                if (row.winner) winners[row.class_id] = row.winner;
              });
            }
          } catch (_) {}
          setShootoutWinners(winners);
        }
      } catch (e) {
        console.error(e);
      }
      setIsLoading(false);
    };
    fetchData();
  }, [id]);

  const uniqueClassNames = [];

  return (
    <div className="mainCon">
      <Header />
      <div className="innerBanner event">
        <div className="container flexBox">
          <div>
            <div className="innerHd">Event Results</div>
            <div className="bradcrumb">
              <a href="/">Home</a>
              <a href="/club-result">Completed Events</a>
            </div>
          </div>
        </div>
      </div>

      <div className="pb50 grayBg">
        <div className="container">
          <div className="whtBox">
            <ul className="eventTab flexBox">
              <li><NavLink to="/club-upcoming">Upcoming Events</NavLink></li>
              <li><NavLink to="/club-result">Completed Events</NavLink></li>
              <li><NavLink to="/series-result">Race Series</NavLink></li>
            </ul>

            {isLoading ? (
              <div className="text-center mt-4 loadMore">
                <Spinner color="primary" />
              </div>
            ) : (
              <>
                <h4 style={{ padding: "15px 20px 5px", marginBottom: 0 }}>{title}</h4>

                <div className="podium-view-toggle" style={{ padding: "10px 15px" }}>
                  <Button
                    variant={viewMode === "podium" ? "contained" : "outlined"}
                    onClick={() => setViewMode("podium")}
                    size="small"
                  >
                    Podium
                  </Button>
                  <Button
                    variant={viewMode === "scorecard" ? "contained" : "outlined"}
                    onClick={() => setViewMode("scorecard")}
                    size="small"
                  >
                    Scorecard
                  </Button>
                </div>

                {viewMode === "podium" && (
                  <>
                    <div className="podium-view-toggle">
                      <Button
                        variant={podiumViewMode === "full" ? "contained" : "outlined"}
                        onClick={() => setPodiumViewMode("full")}
                        size="small"
                      >
                        Full View
                      </Button>
                      <Button
                        variant={podiumViewMode === "photosOnly" ? "contained" : "outlined"}
                        onClick={() => setPodiumViewMode("photosOnly")}
                        size="small"
                      >
                        Photos Only
                      </Button>
                    </div>
                    {podiumList.length > 0 ? (
                      podiumList
                        .sort((a, b) => a?.class_type?.name?.localeCompare(b?.class_type?.name))
                        .map((podium, index) => (
                          <div className="podium-container" key={index}>
                            <h5 className="podium-title">{podium?.class_type?.name}</h5>
                            <div className="podium-content">
                              <div className="podium-image">
                                <img src={podium?.photo_url} alt="Podium" />
                              </div>
                              {podiumViewMode === "full" && podium.specs.length !== 0 ? (
                                <div className="specs-table-wrapper">
                                  <table className="specs-table">
                                    <tbody>
                                      {podium?.specs?.map((spec, i) => (
                                        <tr key={i} className={i % 2 !== 0 ? "even-row" : "odd-row"}>
                                          <td className="driver-info">
                                            <div className="position">Position {spec?.position}</div>
                                            <div className="driver-name">
                                              {spec?.driver?.user_firstname} {spec?.driver?.user_lastname}
                                            </div>
                                          </td>
                                          <td className="spec-details">
                                            <div><b>Radio:</b> {spec?.radio}</div>
                                            <div><b>Boat:</b> {spec?.boat_model}</div>
                                            <div><b>Engine:</b> {spec?.motor_engine}</div>
                                          </td>
                                          <td className="spec-details">
                                            <div><b>Prop:</b> {spec?.prop}</div>
                                            {spec?.fuel_battery !== "none" && <div><b>Fuel:</b> {spec?.fuel_battery}</div>}
                                            {spec?.esc !== "none" && <div><b>ESC:</b> {spec?.esc}</div>}
                                          </td>
                                        </tr>
                                      ))}
                                    </tbody>
                                  </table>
                                </div>
                              ) : podiumViewMode === "full" && podium.specs.length === 0 ? (
                                <p className="no-specs">No specifications available.</p>
                              ) : null}
                            </div>
                          </div>
                        ))
                    ) : (
                      <div className="resultTbleImg1">
                        <img src={scorenImg} alt="Score Not Found" />
                      </div>
                    )}
                  </>
                )}

                {viewMode === "scorecard" && (
                  <div style={{ padding: "0 15px" }}>
                    {scoreRacer?.length > 0 ? (
                      scoreRacer.map((value, index) => {
                        if (!uniqueClassNames.includes(value.class_Name)) {
                          uniqueClassNames.push(value.class_Name);
                          return (
                            <div className="rsultTable" key={index}>
                              <h5 style={{ marginLeft: "15px" }}>{value.class_Name}</h5>
                              {shootoutWinners[value.class_Id] && (
                                <p style={{ marginLeft: "15px", color: "#856404" }}>
                                  Shootout Winner: {shootoutWinners[value.class_Id].driver_name}
                                </p>
                              )}
                              <table cellPadding="0" cellSpacing="0">
                                <thead>
                                  <tr>
                                    <th className="tal" style={{ textAlign: "left", paddingLeft: "15px", width: "30%" }}>Drivers</th>
                                    <th className="tar" style={{ textAlign: "right", width: "10%" }}>R1</th>
                                    <th className="tar" style={{ textAlign: "right", width: "10%" }}>R2</th>
                                    <th className="tar" style={{ textAlign: "right", width: "10%" }}>R3</th>
                                    {totalRounds >= 4 && <th className="tar" style={{ textAlign: "right", width: "10%" }}>R4</th>}
                                    {totalRounds >= 5 && <th className="tar" style={{ textAlign: "right", width: "10%" }}>R5</th>}
                                    {totalRounds >= 6 && <th className="tar" style={{ textAlign: "right", width: "10%" }}>R6</th>}
                                    {totalRounds >= 7 && <th className="tar" style={{ textAlign: "right", width: "10%" }}>R7</th>}
                                    <th className="tar" style={{ textAlign: "right", paddingRight: "15px", width: "10%" }}><b>Total</b></th>
                                    <th className="tar" style={{ textAlign: "right", width: "10%" }}>FT</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {scoreRacer.map((result, i) =>
                                    value.class_Name === result.class_Name ? (
                                      <tr key={i}>
                                        <td className="tal" style={{ textAlign: "left", paddingLeft: "15px" }}>
                                          <NavLink to={`/race-result-profile/${result.participant_Id}`}>{result.participantName}</NavLink>
                                        </td>
                                        <td className="tar" style={{ textAlign: "right" }}>{result.round1_Score}</td>
                                        <td className="tar" style={{ textAlign: "right" }}>{result.round2_Score}</td>
                                        <td className="tar" style={{ textAlign: "right" }}>{result.round3_Score}</td>
                                        {totalRounds >= 4 && <td className="tar" style={{ textAlign: "right" }}>{result.round4_Score}</td>}
                                        {totalRounds >= 5 && <td className="tar" style={{ textAlign: "right" }}>{result.round5_Score}</td>}
                                        {totalRounds >= 6 && <td className="tar" style={{ textAlign: "right" }}>{result.round6_Score}</td>}
                                        {totalRounds >= 7 && <td className="tar" style={{ textAlign: "right" }}>{result.round7_Score}</td>}
                                        <td className="tar" style={{ textAlign: "right", paddingRight: "15px" }}><b>{result.total}</b></td>
                                        <td className="tar" style={{ textAlign: "right" }}>{findMinFastTime(result.fast_time)}</td>
                                      </tr>
                                    ) : null
                                  )}
                                </tbody>
                              </table>
                            </div>
                          );
                        }
                        return null;
                      })
                    ) : (
                      <div className="resultTbleImg1">
                        <img src={scorenImg} alt="Score Not Found" />
                      </div>
                    )}
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default EventPodiumPage;